/* al-chrome.js — comportamento comum do site (zona B). Sem dependências.
   1) revelação .al-rv -> .on (também depois de shopify:section:load)
   2) sombra do cabeçalho ao rolar
   3) verificação de idade */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ── revelação ao entrar no ecrã ── */
  const reduzido = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window && !reduzido
    ? new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px' })
    : null;
  const observar = (raiz = document) => {
    const els = $$('.al-rv:not(.on)', raiz);
    if (raiz.classList && raiz.classList.contains('al-rv') && !raiz.classList.contains('on')) els.push(raiz);
    els.forEach((el) => (io ? io.observe(el) : el.classList.add('on')));
  };
  observar();
  document.addEventListener('shopify:section:load', (e) => observar(e.target));
  /* conteúdo injetado por JS (filtros, quick add, pesquisa…) */
  if ('MutationObserver' in window) {
    let agendado = false;
    new MutationObserver(() => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(() => { agendado = false; observar(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── cabeçalho ganha sombra ao rolar ── */
  const marcarScroll = () => {
    const cab = document.querySelector('.section-header');
    if (cab) cab.classList.toggle('al-rolado', window.scrollY > 10);
  };
  addEventListener('scroll', marcarScroll, { passive: true });
  marcarScroll();

  /* ── verificação de idade ── */
  const ligarIdade = () => {
    const idade = document.getElementById('al-idade');
    if (!idade || idade.dataset.pronto) return;
    idade.dataset.pronto = '1';
    const texto = idade.querySelector('[data-al-idade-texto]');
    const sim = idade.querySelector('[data-al-idade-sim]');
    const nao = idade.querySelector('[data-al-idade-nao]');
    /* acessibilidade: o resto da página fica inerte enquanto o diálogo está aberto */
    const inertes = [];
    const isolar = (no) => {
      let el = no;
      while (el && el !== document.body) {
        const pai = el.parentElement;
        if (!pai) break;
        Array.from(pai.children).forEach((irmao) => {
          if (irmao !== el && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(irmao.tagName) && !irmao.inert) {
            irmao.inert = true;
            irmao.setAttribute('aria-hidden', 'true');
            inertes.push(irmao);
          }
        });
        el = pai;
      }
    };
    const libertar = () => {
      inertes.forEach((el) => { el.inert = false; el.removeAttribute('aria-hidden'); });
      inertes.length = 0;
      document.removeEventListener('keydown', teclas, true);
    };
    const focaveis = () => $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', idade)
      .filter((el) => !el.disabled && el.offsetParent !== null);
    const teclas = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); return; }
      if (e.key !== 'Tab') return;
      const lista = focaveis();
      if (!lista.length) { e.preventDefault(); return; }
      const primeiro = lista[0];
      const ultimo = lista[lista.length - 1];
      if (!idade.contains(document.activeElement)) { e.preventDefault(); primeiro.focus(); }
      else if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
    };
    idade.setAttribute('aria-modal', 'true');
    isolar(idade);
    document.addEventListener('keydown', teclas, true);
    if (sim) {
      sim.addEventListener('click', () => {
        try { sessionStorage.setItem('al-idade', '1'); } catch (e) {}
        libertar();
        idade.classList.add('fora');
        setTimeout(() => idade.remove(), 900);
      });
      setTimeout(() => sim.focus({ preventScroll: true }), 50);
    }
    if (nao && texto) {
      nao.addEventListener('click', () => {
        if (texto.dataset.textoRecusa) texto.textContent = texto.dataset.textoRecusa;
      });
    }
  };
  ligarIdade();
})();

/* Integração: altura real do cabeçalho fixo em --al-cabecalho-h, usada pela barra de filtros
   da coleção (al-catalogo.css). O Origin muda a altura com o logótipo e o menu. */
(() => {
  const medir = () => {
    const cab = document.querySelector('.section-header');
    if (cab) document.documentElement.style.setProperty('--al-cabecalho-h', cab.offsetHeight + 'px');
  };
  medir();
  window.addEventListener('resize', medir, { passive: true });
  document.addEventListener('shopify:section:load', medir);
})();
